<template>
  <div class="loyalty-card">
    <p class="loyalty-card__head">
      <span class="loyalty-card__head-icon">
        <IconComponent
          height="22"
          width="36"
          view-box="0 0 36 22"
          class="loyalty-card__logo-svg"
        >
          <IconLoyaltyProgram />
        </IconComponent>
      </span>
      <span class="loyalty-card__head-label">
        {{ loyaltyCardTitle }}
      </span>
    </p>
    <p class="loyalty-card__desc">
      <span>
        {{ loyaltyCardText }}
      </span>
    </p>
    <slot />
  </div>
</template>

<script src="./LoyaltyCard.es"></script>
<style scoped lang="scss" src="./LoyaltyCard.scss"></style>
